/**
 * Size unit toggle (cm / in / size).
 *
 * Display is CSS-driven: every label ships all three units in the markup
 * (product-option.liquid) and `[data-active-unit]` on <product-info> picks
 * which one shows. product-info is not replaced when options change, so the
 * picker can be swapped wholesale without the unit reverting or reflowing.
 *
 * This file therefore only persists the choice and keeps aria-pressed in sync.
 */
(function () {
  'use strict';

  var KEY = 'size-unit-preference';
  var UNITS = ['cm', 'in', 'size'];

  function storedUnit() {
    try {
      var unit = localStorage.getItem(KEY);
      return UNITS.indexOf(unit) === -1 ? 'cm' : unit;
    } catch (e) {
      return 'cm';
    }
  }

  function apply(unit) {
    document.querySelectorAll('product-info').forEach(function (scope) {
      scope.dataset.activeUnit = unit;
    });
    document.querySelectorAll('[data-unit-toggle] [data-unit]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-unit-toggle] [data-unit]');
    if (!button) return;

    event.preventDefault();

    var unit = button.dataset.unit;
    if (UNITS.indexOf(unit) === -1) return;

    try {
      localStorage.setItem(KEY, unit);
    } catch (e) {}

    apply(unit);
  });

  apply(storedUnit());

  // The toggle is re-rendered by the server on every option change, so its
  // aria-pressed comes back at the Liquid default. Visual state is CSS and
  // never flickers; this only re-syncs the accessibility attribute.
  // PUB_SUB_EVENTS is a top-level `const`, so it is a global binding but not
  // a window property — check it with typeof, not window.PUB_SUB_EVENTS.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      apply(storedUnit());
    });
  }

  document.addEventListener('shopify:section:load', function () {
    apply(storedUnit());
  });
})();
